<div (click)="onClick()" (keydown.enter)="onClick()" class="menu-item" tabindex="0">
  <div class="menu-item__icon">
    <ng-content select="[slot=icon]"></ng-content>
  </div>
  <div class="menu-item__label">
    <ng-content></ng-content>
  </div>
</div>
